import {
  DownloadLinkType,
  IDownloadLink,
  IDownloadLinkType
} from './download-link-type';

export const IDownloadLinkApiResponse = ({
  url
}: DownloadLinkType): IDownloadLinkType =>
  IDownloadLink({
    url
  });
